import {useEffect} from 'react';

import debounce from 'lodash.debounce';
import {logClientInfo} from 'src/openapi/admin/apis/ClientInfoApi';
import {useAppDispatch} from 'src/store/hooks';

export const useWindowResizeTracking = () => {
    const apiDispatch = useAppDispatch();

    useEffect(() => {
        const handleResize = debounce(() => {
            const clientInfo = {
                clientInfo: {
                    screenWidth: window.screen.width,
                    screenHeight: window.screen.height,
                    innerWidth: window.innerWidth,
                    innerHeight: window.innerHeight,
                    zoomLevel: Math.round((window.outerWidth / window.innerWidth) * 100),
                },
            };

            apiDispatch(logClientInfo(clientInfo));
        }, 500);

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [apiDispatch]);
};
